import React, { useState, useEffect } from 'react';
import "./cartRenew.min.css";
import { Modal } from 'react-bootstrap';
import LnModule from '../LandingModule/LnModule';
import { useSelector, useDispatch } from 'react-redux';
import { removeAddonModule } from '../../Redux/slices/addonModulesSlice';
import { Link, useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { BMSuRlREACT, PrivateAxios } from '../../environment/AxiosInstance';
import { ReactComponent as Task } from '../LandingModule/task-icon.svg';
import { ReactComponent as Checklist } from '../LandingModule/checklist-icon.svg';
import { ReactComponent as Workflow } from '../LandingModule/workflow-icon.svg';
import { ErrorMessage, SuccessMessage } from '../../environment/ToastMessage';
import { UserAuth } from '../auth/Auth';
import Swal from 'sweetalert2';


function CartPageRenew(props) {
  const { skipOrGetStart, planDetails } = props;
  const navigate = useNavigate();
  const { companyDetails } = UserAuth();



  const selectedPlan = useSelector((state) => state.selectedPlan);
  const addonModules = useSelector((state) => state.addonModules);
  const skipOrGet = useSelector((state) => state.skipGet);
  const dispatch = useDispatch();

  const [addonRemoveShow, setAddonRemoveShow] = useState(false);
  const [selectedAddon, setSelectedAddon] = useState(null);
  const [addMoreModuleModalShow, setAddMoreModuleModalShow] = useState(false);
  const [showAfterSelectPlan, setShowAfterSelectPlan] = useState(false);
  const [showBillingCard, setShowBillingCard] = useState(false);
  const [modules, setModules] = useState([]);
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [userCount, setUserCount] = useState(5);
  const [billingName, setBillingName] = useState('');
  const [billingEmail, setbillingEmail] = useState('');
  const [billingPhone, setBillingPhone] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [billingState, setBillingState] = useState('');
  const [billingCity, setBillingCity] = useState('');
  const [billingZip, setBillingZip] = useState('');
  const [gstRegistered, setGstRegistered] = useState(null); // true or false
  const [gstCompanyName, setGstCompanyName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [gstCompanyAddress, setGstCompanyAddress] = useState('');
  const [companyId, setCompanyId] = useState(null);
  const hideRemoveAddonModal = () => setAddonRemoveShow(false);
  const [isLoading, setIsLoading] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [couponDiscount, setCouponDiscount] = useState(0);

  const showRemoveAddonModal = (addon) => {
    setSelectedAddon(addon);
    setAddonRemoveShow(true);
  };

  const handleRemoveAddon = () => {
    if (selectedAddon) {
      dispatch(removeAddonModule({ id: selectedAddon.id }));
    }
    hideRemoveAddonModal();
  };

  const hideAddModuleModal = () => setAddMoreModuleModalShow(false);
  const showAddonModuleModal = () => setAddMoreModuleModalShow(true);

  const handleSelectPlan = (type) => {
    setBillingCycle(type); // 'monthly' or 'yearly'
    setUserCount(1);        // default 1 employee
    setShowAfterSelectPlan(true);
  };

  const handleBillingCard = () => {
    if (showBillingCard) {
      handleCheckout();
    } else {
      setShowBillingCard(true);
    }
  };

  useEffect(() => {
    const stored = localStorage.getItem('selectedModules');
    if (stored) {
      setModules(JSON.parse(stored));
    }
  }, []);

  // const calculateTotal = () => {
  //   return modules.reduce((sum, mod) => {
  //     const pricePerUser = billingCycle === 'yearly' ? mod.yearly * 0.8 : mod.monthly;
  //     return sum + pricePerUser * userCount;
  //   }, 0);
  // };

  useEffect(() => {
    const companyId = companyDetails.id;
    setCompanyId(companyId);
  }, []);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleCheckout = async () => {
    setIsLoading(true);
    const isScriptLoaded = await loadRazorpayScript();

    if (!isScriptLoaded) {
      alert('Razorpay SDK failed to load. Are you online?');
      return;
    }

    const totalMonthly = modules.reduce((sum, mod) => sum + mod.monthly, 0);
    const totalYearly = modules.reduce((sum, mod) => sum + mod.yearly, 0);



    const totalBase = billingCycle === 'monthly'
      ? totalMonthly * userCount
      : totalYearly * 12 * userCount;

    const supportAmount = extendedSupport; // actual selected support
    const taxableAmount = totalBase + supportAmount;
    const gst = Math.round(taxableAmount * 0.18);
    const total = taxableAmount + gst - couponDiscount;

    const payload = {

      company_id: companyId,
      billing_cycle: billingCycle,
      employees: userCount,
      total_base: totalBase,
      extended_support: supportAmount,
      gst,
      coupon_discount: couponDiscount,
      total,
      modules,
      billingDetails: {
        billing_name: billingName,
        billingEmail: billingEmail,
        billing_phone: billingPhone,
        billing_address: billingAddress,
        billing_state: billingState,
        billing_city: billingCity,
        billing_zip: billingZip,
        gst_registered: gstRegistered,
        gst_company_name: gstCompanyName,
        gst_number: gstNumber,
        gst_address: gstCompanyAddress,
      }
    };

    try {
      // 1. Save order data in your DB
      const res = await PrivateAxios.post('/company/module-order-renew', payload);
      const orderResponse = res.data;
      const orderId = orderResponse.orderId;

      // 2. Create Razorpay order
      const razorRes = await PrivateAxios.post('/company/create-razorpay-order', {
        amount: Math.round(total * 100),
        currency: "INR",
        receipt: `receipt_${new Date().getTime()}`,
        company_id: companyId
      });

      const { id: razorpayOrderId } = razorRes.data;

      // 3. Initialize Razorpay Checkout
      const options = {
        key: process.env.RAZORPAY_KEY_ID || 'rzp_live_sSKQUkmSSOi1Un',
        amount: Math.round(total * 100),
        currency: "INR",
        name: billingName,
        description: "Growthh Module Purchase",
        order_id: razorpayOrderId,
        handler: async function (response) {
          const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;

          try {
            const verifyPayload = {
              orderId, // internal DB order ID
              razorpay_payment_id,
              razorpay_order_id,
              razorpay_signature
            };

            const verifyRes = await PrivateAxios.post('/company/payment-verify-renew', verifyPayload);

            if (verifyRes.data.success) {
              Swal.fire({
                title: 'Success!',
                text: 'Payment successful and verified',
                icon: 'success',
                timer: 3000,
                showConfirmButton: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });

              navigate(`/thank-you?orderId=${orderId}&txnId=${razorpay_payment_id}`);
            } else {
              setIsLoading(false);
              Swal.fire({
                title: 'Error!',
                text: 'Payment verification failed',
                icon: 'error',
                timer: 3000,
                showConfirmButton: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });

            }
          } catch (error) {
            setIsLoading(false);
            console.error('Payment verification error:', error);
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong during payment verification.',
              icon: 'error',
              timer: 3000,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });

          }
        },
        prefill: {
          name: billingName,
          email: billingEmail,
          contact: billingPhone
        },
        notes: {
          company_id: companyId
        },
        theme: {
          color: "#3399cc"
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.log(err);

      console.error("Payment failed:", err);
      //alert("Order failed or payment could not be initiated.");
    }
  };



  const discountedPrices = modules.map(mod => ({
    name: mod.name,
    monthly: mod.monthly,
    yearly: mod.yearly
  }));

  const totalMonthly = modules.reduce((sum, mod) => sum + mod.monthly, 0);
  const totalYearly = modules.reduce((sum, mod) => sum + mod.yearly, 0);

  const totalBase = billingCycle === 'monthly'
    ? totalMonthly * userCount
    : totalYearly * 12 * userCount;

  const [extendedSupport, setExtendedSupport] = useState(15000);

  const supportAmount = extendedSupport;
  const taxableAmount = totalBase + supportAmount;
  const gst = Math.round(taxableAmount * 0.18);
  const total = taxableAmount + gst - couponDiscount;

  const handleSupportChange = (amount) => {
    setExtendedSupport(amount);
  };
  const getNextChargeDate = () => {
    const currentDate = new Date();
    if (billingCycle === 'monthly') {
      currentDate.setMonth(currentDate.getMonth() + 1);
    } else {
      currentDate.setFullYear(currentDate.getFullYear() + 1);
    }
    return currentDate.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };
  const handleApplyCoupon = async () => {
    try {
      const res = await PrivateAxios.get(`${BMSuRlREACT}get-coupon`);
      if (res.data.success) {
        const validCoupons = res.data.data;
        const found = validCoupons.find(c =>
          c.code.toLowerCase() === couponCode.trim().toLowerCase() &&
          new Date(c.date) >= new Date() &&
          c.is_delete === 0
        );
        if (found) {
          setCouponDiscount(parseFloat(found.amount));
          Swal.fire({
            title: 'Success!',
            text: `Coupon applied! ₹${found.amount} discount.`,
            icon: 'success',
            timer: 2000,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        } else {
          setCouponDiscount(0);
          Swal.fire({
            title: 'Error!',
            text: 'Invalid or expired coupon code.',
            icon: 'error',
            timer: 2000,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        }
      }
    } catch (error) {
      console.error("Coupon error:", error);
      ErrorMessage("Failed to apply coupon. Try again.");
    }
  };

  return (
    <>


      {/* new develop part */}
      <section className="ln-cart-sec position-relative">
        <div className='container mb-5'>
          <h3 className='text-center mb-3'>Selected Modules</h3>
          {modules.length === 0 ? (
            <p className="text-center text-danger">No modules selected</p>
          ) : (
            <div className="module-list-wrap">
              {discountedPrices.map((mod) => (
                <label key={mod.name} className="custom-checkbox module-checkbox-list-item">
                  <input type="checkbox" checked readOnly disabled />
                  <span className="checkmark"></span>
                  <span className="module-icon">
                    {mod.name === 'Task' && <Task width={46} className="text-success" />}
                    {mod.name === 'Checklist' && <Checklist width={46} className="text-success" />}
                    {mod.name === 'Workflow' && <Workflow width={46} className="text-success" />}
                  </span>
                  <span className="module-name">{mod.name}</span>
                </label>

              ))}
            </div>
          )}
        </div>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-5'>
              <div className='card text-center rounded-4 mb-4'>
                <div className='card-body'>
                  <h4 className='mb-2 text-uppercase text-primary'>Monthly Flex</h4>
                  <p className='fw-bold fs-5'>&#8377; <span className='fs-1'>{totalMonthly}<sup>*</sup></span></p>
                  <p className='text-muted fs-6 mb-4'>
                    /user/month (billed monthly)<br />
                    No long-term commitments. Start, stop, or <br />scale anytime.
                  </p>
                  <p className='fs-6 mb-3'>
                    Pay-as-you-go flexibility<br />
                    Ideal for short-term projects or pilot teams<br />
                    Full feature access included
                  </p>
                  <button
                    className='main-btn select__plan_btn px-4'
                    onClick={() => {
                      handleSelectPlan('monthly');
                      setTimeout(() => {
                        const billingSection = document.getElementById('billing_1');
                        if (billingSection) {
                          const y = billingSection.getBoundingClientRect().top + window.pageYOffset - 100;
                          window.scrollTo({ top: y, behavior: 'smooth' });
                        }
                      }, 100);
                    }}
                  >
                    Select Plan
                  </button>
                </div>
              </div>
            </div>
            <div className='col-md-5'>
              <div className='card text-center rounded-4 mb-4'>
                <div className='card-body'>
                  <h4 className='mb-2 text-uppercase text-primary'>Annual Pro</h4>
                  <p className='fw-bold fs-5'>&#8377; <span className='fs-1'>{totalYearly.toFixed(0)}<sup>*</sup></span></p>
                  <p className='text-muted fs-6 mb-4'>
                    /user/month (billed annually)<br />
                    Best value for growing teams who want to commit and save.
                  </p>
                  <p className='fs-6 mb-3'>
                    Locked-in pricing for 12 months<br />
                    Priority support & early access to new features<br />
                    Great for long-term planning
                  </p>
                  <button
                    className='main-btn select__plan_btn px-4'
                    onClick={() => {
                      handleSelectPlan('yearly');
                      setTimeout(() => {
                        const billingSection = document.getElementById('billing_1');
                        if (billingSection) {
                          const y = billingSection.getBoundingClientRect().top + window.pageYOffset - 100;
                          window.scrollTo({ top: y, behavior: 'smooth' });
                        }
                      }, 100);
                    }}
                  >
                    Select Plan
                  </button>
                </div>
              </div>
            </div>
            <div className='col-md-10'>
              <div className='card rounded-4 mb-4'>
                <div className='card-body pb-2'>
                  <div class="row">
                    <div className='col-12 mb-2'>
                      <h4>Features**</h4>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <p>✔ Admin dashboard & user controls</p>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <p>✔ Mobile apps included</p>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <p>✔ Secure & scalable</p>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <p>✔ One invoice, no hidden fees</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showAfterSelectPlan && (
          <div className='container after_select_plan'>
            <div className='row'>
              <div className='col-lg-7'>
                <div className='card rounded-4 mb-4' id="billing_1">
                  <div className='card-body pb-2'>
                    <h5 className='text-primary'>All Employees</h5>
                    <hr className='border-dark' />
                    <div className='row'>
                      <div className='col-sm-6 col-5'>
                        <p className='mb-0 fs-6 fw-bold'>No of Employees</p>
                        <p className='fs-6'>₹{billingCycle === 'monthly' ? totalMonthly : Math.round(totalYearly)} /employee/{billingCycle}</p>
                      </div>
                      <div className='col-sm-3 col-4'>
                        <input
                          type="number"
                          className='form-control'
                          min={1}
                          value={userCount}
                          onChange={(e) => setUserCount(Number(e.target.value))}
                        />
                      </div>
                      <div className='col-sm-3 col-3'>
                        <p className='fs-5 text-end mb-0 fw-bold'>₹{totalBase.toFixed(0)}</p>
                      </div>
                    </div>
                    <hr className='border-dark' />
                    <div className='row'>
                      <div className='col-12'>
                        <h5 className='mb-2'>Extended Support</h5>
                        <div>
                          <label className="custom-radio me-0 mb-2 d-inline-flex">
                            <input
                              type="radio"
                              name="support"
                              checked={extendedSupport === 15000}
                              onChange={() => handleSupportChange(15000)}
                            />
                            <span className="checkmark" />
                            <span className="text-">3 Months: ₹15,000</span>
                          </label>
                        </div>
                        <div>
                          <label className="custom-radio me-0 mb-2 d-inline-flex">
                            <input
                              type="radio"
                              name="support"
                              checked={extendedSupport === 25000}
                              onChange={() => handleSupportChange(25000)}
                            />
                            <span className="checkmark" />
                            <span className="text-">6 Months: ₹25,000</span>
                          </label>
                        </div>
                        <div>
                          <label className="custom-radio me-0 mb-2 d-inline-flex">
                            <input
                              type="radio"
                              name="support"
                              checked={extendedSupport === 45000}
                              onChange={() => handleSupportChange(45000)}
                            />
                            <span className="checkmark" />
                            <span className="text-">12 Months: ₹45,000</span>
                          </label>
                        </div>
                        <div>
                          <label className="custom-radio me-0 mb-2 d-inline-flex">
                            <input
                              type="radio"
                              name="support"
                              checked={extendedSupport === 0}
                              onChange={() => handleSupportChange(0)}
                            />
                            <span className="checkmark" />
                            <span className="text-">None</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Show billing__card only if showBillingCard is true */}
                {showBillingCard && (
                  <div className='card rounded-4 mb-4 billing__card' id="billing_2">
                    <div className='card-body'>
                      <h5 className='text-primary'>Billing Details</h5>
                      <hr className='border-dark' />
                      <div className='row'>
                        <div className='col-md-6'>
                          <div className='form-group'>
                            <label className='form-label'>Billing Name</label>
                            <input type='text' className='form-control' placeholder='Enter Billing Name'
                              value={billingName} onChange={(e) => setBillingName(e.target.value)} />
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='form-group'>
                            <label className='form-label'>Billing Email</label>
                            <input type='text' className='form-control' placeholder='Enter Billing Email'
                              value={billingEmail} onChange={(e) => setbillingEmail(e.target.value)} />
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='form-group'>
                            <label className='form-label'>Phone Number</label>
                            <PhoneInput country={'in'} value={billingPhone} onChange={setBillingPhone} />
                          </div>
                        </div>

                        <div className='col-md-6'>
                          <div className='form-group'>
                            <label className='form-label'>Street Address</label>
                            <input type='text' className='form-control' placeholder='Enter Street Address'
                              value={billingAddress} onChange={(e) => setBillingAddress(e.target.value)} />
                          </div>
                        </div>

                        <div className='col-md-6'>
                          <div className='form-group'>
                            <label htmlFor="state">Select State</label>
                            <select name="state" id="state" className='form-select'
                              value={billingState} onChange={(e) => setBillingState(e.target.value)}>
                              <option value="">-- Select State --</option>
                              <option value="Andhra Pradesh">Andhra Pradesh</option>
                              <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                              <option value="Assam">Assam</option>
                              <option value="Bihar">Bihar</option>
                              <option value="Chhattisgarh">Chhattisgarh</option>
                              <option value="Goa">Goa</option>
                              <option value="Gujarat">Gujarat</option>
                              <option value="Haryana">Haryana</option>
                              <option value="Himachal Pradesh">Himachal Pradesh</option>
                              <option value="Jharkhand">Jharkhand</option>
                              <option value="Karnataka">Karnataka</option>
                              <option value="Kerala">Kerala</option>
                              <option value="Madhya Pradesh">Madhya Pradesh</option>
                              <option value="Maharashtra">Maharashtra</option>
                              <option value="Manipur">Manipur</option>
                              <option value="Meghalaya">Meghalaya</option>
                              <option value="Mizoram">Mizoram</option>
                              <option value="Nagaland">Nagaland</option>
                              <option value="Odisha">Odisha</option>
                              <option value="Punjab">Punjab</option>
                              <option value="Rajasthan">Rajasthan</option>
                              <option value="Sikkim">Sikkim</option>
                              <option value="Tamil Nadu">Tamil Nadu</option>
                              <option value="Telangana">Telangana</option>
                              <option value="Tripura">Tripura</option>
                              <option value="Uttar Pradesh">Uttar Pradesh</option>
                              <option value="Uttarakhand">Uttarakhand</option>
                              <option value="West Bengal">West Bengal</option>
                              <option value="Delhi">Delhi</option>
                              <option value="Chandigarh">Chandigarh</option>
                              <option value="Puducherry">Puducherry</option>
                            </select>
                          </div>
                        </div>

                        <div className='col-md-6'>
                          <div className='form-group'>
                            <label className='form-label'>City</label>
                            <input type='text' className='form-control' placeholder='Enter City'
                              value={billingCity} onChange={(e) => setBillingCity(e.target.value)} />
                          </div>
                        </div>

                        <div className='col-md-6'>
                          <div className='form-group'>
                            <label className='form-label'>Zip</label>
                            <input type='text' className='form-control' placeholder='Enter Zipcode'
                              value={billingZip} onChange={(e) => setBillingZip(e.target.value)} />
                          </div>
                        </div>

                        <div className='col-md-12'>
                          <div className='form-group mb-0'>
                            <label className='form-label'>Are you registered for GSTIN?</label>
                            <div className="d-flex flex-wrap">
                              <label className="custom-radio me-3 mb-2">
                                <input type="radio" name="gst" checked={gstRegistered === true}
                                  onChange={() => setGstRegistered(true)} />
                                <span className="checkmark" />
                                <span className="text-">Yes</span>
                              </label>
                              <label className="custom-radio me-3 mb-2">
                                <input type="radio" name="gst" checked={gstRegistered === false}
                                  onChange={() => setGstRegistered(false)} />
                                <span className="checkmark" />
                                <span className="text-">No</span>
                              </label>
                            </div>

                            {gstRegistered && (
                              <div className='have__gstin p-3 border rounded-3 mt-2'>
                                <div className='form-group'>
                                  <label className='form-label'>Company Name <span className='text-danger'>*</span></label>
                                  <input type='text' className='form-control' placeholder='Enter Company Name'
                                    value={gstCompanyName} onChange={(e) => setGstCompanyName(e.target.value)} />
                                </div>
                                <div className='form-group'>
                                  <label className='form-label'>GST No <span className='text-danger'>*</span></label>
                                  <input type='text' className='form-control' placeholder='Enter GST Number'
                                    value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
                                </div>
                                <div className='form-group mb-0'>
                                  <label className='form-label'>Company Address <span className='text-danger'>*</span></label>
                                  <input type='text' className='form-control' placeholder='Enter Company Address'
                                    value={gstCompanyAddress} onChange={(e) => setGstCompanyAddress(e.target.value)} />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                )}
              </div>
              <div className='col-lg-5'>
                <div className="plan-details-wrap">
                  <div className="card plan-details-card">
                    <div className="card-body">
                      <h5 className='text-primary'>Summery</h5>
                      <hr className='border-dark' />
                      <table className="custom-table">
                        <tr>
                          <th>
                            <span className='fw-bold text-default'><span className='text-capitalize'>{billingCycle}</span> Flex</span>
                          </th>
                          <th>
                            <span className="">&#8377; <span>{totalBase.toFixed(0)}</span></span>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <span className='fw-bold text-default'>Extended Support</span>
                          </th>
                          <th>
                            <span className="">&#8377; <span>{supportAmount}</span></span>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <span className='fw-bold text-default'>GST (18%)</span>
                          </th>
                          <th>
                            <span className="">&#8377; <span>{gst}</span></span>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <span className='fw-bold text-danger'>Coupon Discount</span>
                          </th>
                          <th>
                            <span className="text-danger">- &#8377; <span>{couponDiscount}</span></span>
                          </th>
                        </tr>
                        <tr className="border-bottom tbl-foot">
                          <th>
                            <span className="text-dark fs-5">Total</span>
                          </th>
                          <th>
                            <span className="fs-5">&#8377; <span className='fs-5'>{total.toFixed(0)}</span></span>
                          </th>
                        </tr>
                      </table>
                      <div className='d-flex justify-content-between align-items-center mt-3 gap-3'>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Enter Coupon Code'
                          value={couponCode}
                          onChange={(e) => setCouponCode(e.target.value)}
                        />
                        <button className='btn main-btn' onClick={handleApplyCoupon}>Apply</button>
                      </div>
                      <p className="my-3"><small>Next charge date: {getNextChargeDate()}</small></p>
                      <div className="text-center mt-3">
                        <button
                          className="gtn-success-btn text-uppercase add_billing_card"
                          onClick={() => {
                            handleBillingCard();
                            setTimeout(() => {
                              const billingSection = document.getElementById('billing_2');
                              if (billingSection) {
                                const y = billingSection.getBoundingClientRect().top + window.pageYOffset - 100;
                                window.scrollTo({ top: y, behavior: 'smooth' });
                              }
                            }, 100);
                          }}
                        >
                          {showBillingCard ? "Proceed to Pay" : "Continue"}
                        </button>
                        <p className='mb-0 mt-4'>By proceeding, you are agree to our <a href='/privacy-policy'>Privacy Policy</a></p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      {/* module remove modal */}
      <Modal show={addonRemoveShow} onHide={hideRemoveAddonModal} backdrop="static" keyboard={false} centered>
        <Modal.Body className="bg-warning-light rounded-top-left-10 rounded-top-right-10">
          <div className="delete-warning-wrap text-center">
            <div className="delete-warning-icon mb-0 mt-2">
              <i className="fi fi-sr-triangle-warning text-warning"></i>
            </div>
            <h4 className="text-dark mb-2">Are you sure?</h4>
            <p className="text-muted">Do you really want to remove this module? <br />This process cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button onClick={hideRemoveAddonModal} className="btn btn-secondary">
            Close
          </button>
          <button onClick={handleRemoveAddon} className="btn btn-exp-red">
            Remove
          </button>
        </Modal.Footer>
      </Modal>
      {/* module remove modal end */}
      {/* module add modal start */}
      <Modal id="moduleAddon" show={addMoreModuleModalShow} onHide={hideAddModuleModal} backdrop="static" keyboard={false} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            <h5>Modules</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='module_page_small'>
            <LnModule addOns={addonModules} onModuleSelect={setModules} />
          </div>
          <div className="text-center mt-3">
            <button className="gtn-success-btn text-uppercase" onClick={hideAddModuleModal}>
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CartPageRenew;
